import React from "react";
import {
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    Paper,
  } from "@mui/material";
const UberTripEventDetailedInfo = ({ tncExternalDispatch }) => {
  if (!tncExternalDispatch || tncExternalDispatch.length === 0) return null;

  const parsedData = tncExternalDispatch.map((dispatch) => {
    try {
      return JSON.parse(dispatch.vHistoryReqPayload);
    } catch (err) {
      console.error("Invalid JSON payload:", dispatch.vHistoryReqPayload);
      return null;
    }
  }).filter(Boolean)
  .sort((a, b) => a.event_time - b.event_time); // remove nulls

    return (
        <TableContainer component={Paper} sx={{ mt: 2 }}>
        <Table>
            <TableHead>
            <TableRow>
                <TableCell>#</TableCell>
                {/* <TableCell>Event ID</TableCell> */}
                <TableCell>Event Time</TableCell>
                <TableCell>Event Type</TableCell>
                <TableCell>Status</TableCell>
                {/* <TableCell>User ID</TableCell>
                <TableCell>Org UUID</TableCell>
                <TableCell>Resource ID</TableCell>
                <TableCell>Resource Href</TableCell> */}
            </TableRow>
            </TableHead>
            <TableBody>
            {parsedData.map((payload, index) => (
                <TableRow key={index}>
                <TableCell>{index + 1}</TableCell>
                {/* <TableCell>{payload.event_id}</TableCell> */}
                <TableCell>{new Date(payload.event_time * 1000).toLocaleString()}</TableCell>
                <TableCell>{payload.event_type}</TableCell>
                <TableCell>{payload.meta?.status}</TableCell>
                {/* <TableCell>{payload.meta?.user_id}</TableCell>
                <TableCell>{payload.meta?.org_uuid}</TableCell>
                <TableCell>{payload.meta?.resource_id}</TableCell>
                <TableCell>{payload.resource_href}</TableCell> */}
                </TableRow>
            ))}
            </TableBody>
        </Table>
        </TableContainer>
    );
};

export default UberTripEventDetailedInfo;
